import certificateDownload from "./certificateDownload";

const certificateDownloadService = [
    {
        matcher: 'certificateDownload',
        reply: config => {
            return [200, certificateDownload];
        }
    }
]

export default certificateDownloadService;